export class RequestLogin {
  static type = '[User] Login Request';
}
export class RequestLogout {
  static type = '[User] Logout Request';
}
export class LoggedOutPageReady {
  static type = '[User] Logged Out Page Ready';
}
export class LoginSuccess {
  token;
  expirationTime;
  static type = '[User] Login Success';
  constructor(token, expirationTime) {
    this.token = token;
    this.expirationTime = expirationTime;
  }
}
export class UpdateUser {
  userId;
  userName;
  memberships;
  static type = '[User] Update User';
  constructor(userId, userName, memberships) {
    this.userId = userId;
    this.userName = userName;
    this.memberships = memberships;
  }
}
export class UpdateGeaIdUser {
  language;
  country;
  email;
  firstName;
  lastName;
  timezone;
  static type = '[User] Update GeaId User';
  constructor(language, country, email, firstName, lastName, timezone = {
    offset: '',
    zoneId: ''
  }) {
    this.language = language;
    this.country = country;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.timezone = timezone;
  }
}
export class UpdateUserName {
  userName;
  static type = '[User] Update Username';
  constructor(userName) {
    this.userName = userName;
  }
}
export class LoginFailed {
  error;
  static type = '[User] Login Failed';
  constructor(error) {
    this.error = error;
  }
}
export class LogoutFailed {
  static type = '[User] Logout Failed';
}
export class Logout {
  static type = '[User] Logout';
}
